export default "__VITE_ASSET__DEmKiGLj__"